import type { UrTheme } from "themes"

const theme: UrTheme = {
  colors: {
    urGreen: "#37DBD0",
    urBlue: "#0077C0",
    urShadow: "#005594",

    primary: "#0077c0",
    secondary: "#37dbd0",
    accent: "#005594",
    highlight: "#2881b8",
    placeholder: "#9d9ca6",

    error: "#dd2c00",
    success: "#4a934a",
    warning: "#b5af0e",
    info: "#2fa3bd",

    gray1: "#3C3D48",
    gray2: "#54555F",
    gray3: "#6B6C74",
    gray4: "#7A7A81",
    gray5: "#9798A1",
    gray6: "#ADAEB4",
    gray7: "#D5D5DC",
    gray8: "#E3E3E8",
    gray9: "#F3F3F3",

    blueGray: "#9dbccf",

    veryLightBlue: "#f2f7fa",
    lightBlue: "#dcecf5",

    text: {
      dark: "#17171a",
      light: "#f8f7fa",
      disabled: "#c6c4cf",
      gray: "#83868a",
    },
    border: {
      default: "#dadadd",
    },
  },
  sizes: {
    defaultBorderRadius: "4px",
  },
  layout: {
    defaultShadow: "0 0 6px 2px rgba(0, 0, 0, 0.2)",
    defaultBorder: "1px solid #dadadd",
  },
  media: {
    mobile: "@media screen and (max-width: 768px)",
    desktop: "@media screen and (min-width: 769px)",
  },
}

export default theme
